const projectTSA = [
  {
    title: "Face Detection ",
    category: "Face Detection with Mediapipe",
    image: "",
    github: "https://github.com/Teachny-Teams/Face-detection",
  },

  {
    title: "Air canvas",
    category: "Paint on the screen with your index finger   ",
    image: "",
    github: "https://github.com/Teachny-Teams/Air-canvas",
  },
  {
    title: "Face Detection ",
    category: "Face Detection with haar cascade algorithm",
    image: "",
    github: "https://github.com/Teachny-Teams/Face-detector",
  },
  {
    title: "Fingers Volume control",
    category: "Volume control with the index finger and thumb",
    image: "",
    github: "https://github.com/Teachny-Teams/Fingers-Volume-control",
  },
  {
    title: "Hand Detection",
    category: "Hand Detection with mediapipe",
    image: "",
    github: "https://github.com/Teachny-Teams/Hand-detection",
  },
  {
    title: "Face Mesh",
    category: "Face Detection Mesh detecting 400+ points",
    image: "",
    github: "https://github.com/Teachny-Teams/Face-Mesh",
  },
  {
    title: "Object Detection - Yolo",
    category: "Object Detection With Yolo",
    image: "",
    github: "https://github.com/Teachny-Teams/Yolo-object-Detection",
  },
  {
    title: "Object Detection - SSD",
    category: "Object Detection With SSD Mobilenet",
    image: "",
    github: "https://github.com/Teachny-Teams/SSD-Mobilenet-Object-Detectoion-",
  },
  {
    title: "Youtube Downloader",
    category: "Download any youtube video in the preffered format",
    image: "",
    github: "https://github.com/Teachny-Teams/Youtube-to-MP4",
  },
];

export default projectTSA;
